import {Injectable} from '@angular/core';
import {HttpClient, HttpParams, HttpResponse} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {IBerater} from '../shared/model/berater.model';
import {ExportConfiguration, ExportPayload, RenderPayload} from '../shared/model/export-payload.model';
import {PagedResponse} from '../shared/model/request.model';

@Injectable({providedIn: 'root'})
export class ExportService {
  public resourceUrl = environment.apiConfig.uri + 'export';

  constructor(protected http: HttpClient) {
  }

  regenerateBerater(id: string): Observable<IBerater> {
    return this.http.post<IBerater>(
      `${environment.apiConfig.uri}api/export/${id}/regenerate`,
      id
    );
  }

  /**
   * Legt eine Vorlage an. Ist der Name je (Berater, Name, Typ) belegt, antwortet das Backend
   * mit 409 und nennt die bestehende configId — aktualisiert wird ueber updateConfiguration.
   */
  submitProfile(beraterId: string, payload: ExportPayload): Observable<ExportConfiguration> {
    return this.http.post<ExportConfiguration>(
      `${environment.apiConfig.uri}api/berater/${beraterId}/export-configurations`,
      payload
    );
  }

  updateConfiguration(beraterId: string, configId: string, payload: ExportPayload): Observable<ExportConfiguration> {
    return this.http.put<ExportConfiguration>(
      `${environment.apiConfig.uri}api/berater/${beraterId}/export-configurations/${configId}`,
      payload
    );
  }

  getConfigurations(beraterId: string): Observable<PagedResponse<ExportConfiguration>> {
    return this.http.get<PagedResponse<ExportConfiguration>>(
      `${environment.apiConfig.uri}api/berater/${beraterId}/export-configurations`
    );
  }

  getConfiguration(beraterId: string, configId: string): Observable<ExportConfiguration> {
    return this.http.get<ExportConfiguration>(
      `${environment.apiConfig.uri}api/berater/${beraterId}/export-configurations/${configId}`
    );
  }

  deleteConfiguration(beraterId: string, configId: string): Observable<void> {
    return this.http.delete<void>(
      `${environment.apiConfig.uri}api/berater/${beraterId}/export-configurations/${configId}`
    );
  }

  renderExport(beraterId: string, payload: RenderPayload): Observable<HttpResponse<Blob>> {
    return this.http.post(
      `${environment.apiConfig.uri}api/export/${beraterId}/render`,
      payload,
      {responseType: 'blob', observe: 'response'}
    );
  }

  exportAI(id: string, profile: string) {
    const params = new HttpParams().set('id', id);

    const body = {
      text: profile
    };

    return this.http.post(
      `${this.resourceUrl}/parse-profile`,
      body,
      {params}
    );
  }
}
